module.exports = __webpack_public_path__ + "img/Alexandre Lacazette.0428c49a.png";